import React from 'react'
import { CustomDialogContent } from '..'
import { createStyles, makeStyles, Typography, Theme } from '@material-ui/core'

interface IHowToCreateCircleModal {
  onCloseInfoModal: () => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {
      // lineHeight: 2,
      textAlign: 'justify',
      margin: theme.spacing(2, 0),
    },
    strong: {
      fontWeight: 'bold',
    },
  })
)

export const HowToCreateCircleModal = ({
  onCloseInfoModal,
}: IHowToCreateCircleModal) => {
  const classes = useStyles()
  return (
    <CustomDialogContent
      title="How can I create a cirlce?"
      onCancel={onCloseInfoModal}
    >
      <Typography variant="h5" className={classes.contentContainer}>
        Creating a circle is easy peasy.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        1. Hit on <span className={classes.strong}>Add Group</span> Button.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        2. Add a <span className={classes.strong}>name</span> to your group.
      </Typography>
      <Typography variant="body2" className={classes.contentContainer}>
        Example: Gym buddies
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        3. Add a <span className={classes.strong}>description</span> (optional).
      </Typography>
      <Typography variant="body2" className={classes.contentContainer}>
        Example: Training challenges and more
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        4. Add a <span className={classes.strong}>picture</span> (optional)
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        5. Hit <span className={classes.strong}>Create</span> and that&apos;s it
      </Typography>
    </CustomDialogContent>
  )
}
